import { atom, DefaultValue } from "recoil";

// Helper to interact with localStorage safely
const localStorageEffect =
  (key: string) =>
  ({ setSelf, onSet }: any) => {
    if (typeof window !== "undefined") {
      const savedValue = localStorage.getItem(key);
      if (savedValue != null) {
        try {
          setSelf(JSON.parse(savedValue));
        } catch {
          setSelf(savedValue);
        }
      }

      onSet((newValue: any, _: any, isReset: boolean) => {
        if (isReset || newValue instanceof DefaultValue) {
          localStorage.removeItem(key);
        } else {
          localStorage.setItem(
            key,
            typeof newValue === "string" ? newValue : JSON.stringify(newValue),
          );
        }
      });
    }
  };

export const timezoneAtom = atom<string>({
  key: "timezoneAtom",
  default: "UTC",
  effects: [localStorageEffect("app_timezone")],
});
